import "./avatar.scss";

const Avatar = (props: any) => {
  const { imageUrl } = props;
  return <img src={imageUrl} className="avatar" alt="." />;
};

export default Avatar;
